import { ChangeEvent, useCallback, useRef, useState } from "react";

export const useSearchInput = (defaultSearchExpression: string = undefined, delayMs = 250) => {
    const [searchExpression, setSearchExpression] = useState<string>(defaultSearchExpression);
    const [actualSearchExpression, setActualSearchExpression] = useState<string>(defaultSearchExpression);

    const searchExpressionDelay = useRef<NodeJS.Timeout>();
    const handleSearchExpressionChange = useCallback((searchExpression: string) => {
        setActualSearchExpression(searchExpression);

        if (searchExpressionDelay.current) {
            clearTimeout(searchExpressionDelay.current);
            searchExpressionDelay.current = null;
        }

        searchExpressionDelay.current = setTimeout(() => {
            clearTimeout(searchExpressionDelay.current);
            searchExpressionDelay.current = null;

            setSearchExpression(searchExpression);
        }, delayMs);
    }, [delayMs]);

    return {
        searchExpression,
        actualSearchExpression,
        setSearchExpression(searchExpression: string | ChangeEvent<HTMLInputElement>) {
            if (typeof searchExpression === "string") {
                handleSearchExpressionChange(searchExpression);
                return;
            }

            if (typeof searchExpression?.target?.value === "string") {
                handleSearchExpressionChange(searchExpression.target.value);
            }
        },
    };
};
